"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportCampaignRefsResponseSchema = exports.ExportChannelRefsSchema = exports.ExportCampaignRefsQuerySchema = exports.ExportChannelRegionRefsSchema = exports.ExportChannelNegativeKeywordRefsSchema = exports.ExportChannelRegionNegativeKeywordRefsSchema = exports.ExportChannelRegionTargetingKeywordRefsSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const apple_proxy_web_1 = require("../../apple-proxy-web");
exports.ExportChannelRegionTargetingKeywordRefsSchema = (0, core_1.StrictObject)({
    keywordId: core_1.IdSchema,
    adGroupRef: ruby_1.AppleProxyRefSchema,
    keywordRef: ruby_1.AppleProxyRefSchema,
});
exports.ExportChannelRegionNegativeKeywordRefsSchema = (0, core_1.StrictObject)({
    keywordId: core_1.IdSchema,
    adGroupRef: ruby_1.AppleProxyRefSchema,
    keywordRef: ruby_1.AppleProxyRefSchema,
});
exports.ExportChannelNegativeKeywordRefsSchema = (0, core_1.StrictObject)({
    keywordId: core_1.IdSchema,
    campaignRef: ruby_1.AppleProxyRefSchema,
    keywordRef: ruby_1.AppleProxyRefSchema,
});
exports.ExportChannelRegionRefsSchema = (0, core_1.StrictObject)({
    country: core_1.CountrySchema,
    purpose: ruby_1.PurposeSchema,
    orgRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    campaignRef: ruby_1.AppleProxyRefSchema,
    targetingKeywords: typebox_1.Type.Array(exports.ExportChannelRegionTargetingKeywordRefsSchema),
    negativeKeywords: typebox_1.Type.Array(exports.ExportChannelRegionNegativeKeywordRefsSchema),
});
exports.ExportCampaignRefsQuerySchema = (0, core_1.StrictObject)({
    campaignRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
});
exports.ExportChannelRefsSchema = (0, core_1.StrictObject)({
    id: core_1.IdSchema,
    channelType: ruby_1.ChannelTypeSchema,
    structure: ruby_1.ChannelStructureSchema,
    organisationRef: typebox_1.Type.Optional(ruby_1.AppleProxyRefSchema),
    applicationRef: apple_proxy_web_1.AppleProxyAdamRefSchema,
    negativeKeywords: typebox_1.Type.Optional(typebox_1.Type.Array(exports.ExportChannelNegativeKeywordRefsSchema)),
    regions: typebox_1.Type.Array(exports.ExportChannelRegionRefsSchema),
});
exports.ExportCampaignRefsResponseSchema = (0, core_1.StrictObject)({
    campaignId: core_1.IdSchema,
    channels: typebox_1.Type.Array(exports.ExportChannelRefsSchema),
});
